import React from 'react';
import { Card } from 'antd';
import { primaryShades } from '../../../theme/theme';

// Costanti dei colori
const PRIMARY_700 = primaryShades.primary700;
const WHITE = '#ffffff';
const BOX_SHADOW_COLOR = 'rgba(0, 0, 0, 0.04)';

/**
 * Componente che visualizza una card di riepilogo
 * @param {string} title - Titolo della card
 * @param {string|number} value - Valore da visualizzare
 * @param {string} subtitle - Sottotitolo
 */
const SummaryCard = ({ title, value, subtitle }) => {
    return (
        <Card
            style={{
                borderRadius: 'clamp(0.25rem, 2vw, 0.5rem)',
                overflow: 'hidden',
                height: 'clamp(7rem, 15vh, 8.75rem)',
                boxShadow: `0 clamp(0.0625rem, 0.5vw, 0.125rem) clamp(0.25rem, 2vw, 0.5rem) ${BOX_SHADOW_COLOR}`,
                backgroundColor: WHITE,
                marginBottom: 'clamp(0.3125rem, 2vw, 0.625rem)'
            }}
            styles={{ body: { padding: 'clamp(0.75rem, 3vw, 1.25rem)', height: '100%' } }}
        >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                textAlign: 'center',
            }}>
                <div style={{
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                    color: PRIMARY_700,
                    marginBottom: 'clamp(0.3125rem, 2vw, 0.625rem)',
                    textAlign: 'center'
                }}>
                    {title}
                </div>
                <div style={{
                    fontSize: 'clamp(1.75rem, 5vw, 2.375rem)',
                    fontWeight: 'bold',
                    lineHeight: 1,
                    textAlign: 'center',
                    color: PRIMARY_700
                }}>
                    {value}
                </div>
                <div style={{
                    fontSize: 'clamp(0.625rem, 1.5vw, 0.75rem)',
                    color: PRIMARY_700,
                    textTransform: 'uppercase',
                    marginTop: 'clamp(0.25rem, 1vw, 0.3125rem)',
                    textAlign: 'center'
                }}>
                    {subtitle}
                </div>
            </div>
        </Card>
    );
};

export default SummaryCard; 